/**
 * Radio Group Interface
 * Single selection radio buttons with choices
 */

import { Label } from '@/components/ui/label';
import { RadioGroup as ShadRadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { cn } from '@/lib/utils';

interface Choice {
    text: string;
    value: string;
}

interface RadioGroupProps {
    value: string | number | null;
    onChange: (value: string | number | null) => void;
    choices: Choice[];
    disabled?: boolean;
    allowOther?: boolean;
    className?: string;
}

export function RadioGroup({
    value,
    onChange,
    choices,
    disabled = false,
    className,
}: RadioGroupProps) {
    // Determine number of columns based on choices count
    const gridClass = choices.length <= 3
        ? 'grid-cols-1'
        : choices.length <= 6
            ? 'sm:grid-cols-2'
            : 'sm:grid-cols-3';

    return (
        <ShadRadioGroup
            value={value != null ? String(value) : undefined}
            onValueChange={(val) => onChange(val)}
            disabled={disabled}
            className={cn('grid gap-3', gridClass, className)}
        >
            {choices.map((choice) => (
                <div key={choice.value} className="flex items-center space-x-2">
                    <RadioGroupItem value={choice.value} id={`radio-${choice.value}`} />
                    <Label
                        htmlFor={`radio-${choice.value}`}
                        className="cursor-pointer font-normal"
                    >
                        {choice.text}
                    </Label>
                </div>
            ))}
        </ShadRadioGroup>
    );
}
